import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { registerLicense } from '@syncfusion/ej2-base';
import { createRoot } from 'react-dom/client';

import App from './App';
import reportWebVitals from './reportWebVitals';


// **************************************************************************************************************
//                                          In App Styles
//
//      In here we just ony put styles from node modules and not custom css, that are in Public Folder. AntD is in App.css
//
// **************************************************************************************************************

// Styles
import '@syncfusion/ej2/bootstrap4.css'; // this should be enough to get all the bootstrap 4 css
import '@firedesktop/react-base/dist/styles/base.css';
import '@firedesktop/react-base/dist/styles/syncfusion_bootstrap4.css';

// Fonts
import '@fortawesome/fontawesome-free/css/all.css';

// ****************************************************************************************************
//  Syncfusion Doc
//      https://ej2.syncfusion.com/react/documentation/licensing/license-key-registration/#reactjs
//      https://help.syncfusion.com/common/essential-studio/licensing/registering-license-keys
//
//   License:
//          https://www.syncfusion.com/account/login
//          Product: Essential Studio Enterprise Edition Binary with TestStudio
//          Platform: Javascript
//          
//
//  ReactJs
//      https://reactjs.org/blog/2022/03/08/react-18-upgrade-guide.html
//
//  When update this license, also update the license and the verion in react-base
//
// ****************************************************************************************************
registerLicense('ORg4AjUWIQA/Gnt2XFhhQlJHfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTH5Wd0BjXXpbc3NVRWRYWkdx');
/**
 *                                        MSal
 * Initialize a PublicClientApplication instance which is provided to the MsalProvider component
 * We recommend initializing this outside of your root component to ensure it is not re-initialized on re-renders
 *      - Where to setup An Application https://portal.azure.com
 *      - React Tutorial: https://docs.microsoft.com/en-us/azure/active-directory/develop/tutorial-v2-react
 */
let azureAD_Enabled = false;
let msalConfig: any;
try {
    // @ts-ignore
    if (msalConfiguration) {
        azureAD_Enabled = true;
        // @ts-ignore
        msalConfig = msalConfiguration().msalConfig;
    }
} catch (err) { }

const initializeApp = async () => {
    const container = document.getElementById('root');
    if (!container) return;

    const root = createRoot(container);

    if (azureAD_Enabled) {
        try {
            const msalInstance = await PublicClientApplication.createPublicClientApplication(msalConfig);
            root.render(
                // @ts-ignore
                <MsalProvider instance={msalInstance}>
                    <App />
                </MsalProvider>
            );
        } catch (error) {
            console.error('Failed to initialize MSAL:', error);
            // Fallback to non-MSAL render if initialization fails
            root.render(<App />);
        }
    } else {
        root.render(<App />);
    }
};

// Initialize the application
initializeApp();

reportWebVitals();